<template>
    <div class="survey-field-container">
        <survey-group v-if="field.type === 'GROUP'" v-bind:field="field"
                      @nodeChange="onNodeChange"></survey-group>
        <survey-label v-if="field.type === 'LABEL'" v-bind:field="field"></survey-label>
        <template v-if="field.type === 'LIST' && print === true">
          <div v-for="(child, index) in field.children" v-bind:key="index" v-if="checkCompleteness(child)">
            <p class="print_sub_header">{{ child.name }}</p>
            <div v-for="(child2, index2) in child.children" v-bind:key="index2">
              <survey-field v-bind:field="child2" v-bind:key="child2.id" 
                v-bind:print="true"
                @nodeChange="onNodeChange"
              ></survey-field>
            </div>
          </div>
        </template>
        <survey-list v-if="field.type === 'LIST' && print === false" v-bind:field="field"
                     @nodeChange="onNodeChange"></survey-list>
        <survey-exercises v-if="field.type === 'EXERCISES'" v-bind:field="field"
                          @nodeChange="onNodeChange" @modelChange="onModelChange">
        </survey-exercises>
        <survey-recognitions v-if="field.type === 'RECOGNITIONS'" v-bind:field="field"
                             @nodeChange="onNodeChange" @modelChange="onModelChange">
        </survey-recognitions>
        <survey-multiline v-if="field.type === 'MULTILINE'" v-bind:field="field"
            @nodeChange="onNodeChange" @modelChange="onModelChange"></survey-multiline>
        <survey-text v-if="field.type === 'TEXT'" v-bind:field="field"
                     @nodeChange="onNodeChange" @modelChange="onModelChange"></survey-text>
        <survey-int v-if="field.type === 'INT'" v-bind:field="field"
                    @nodeChange="onNodeChange" @modelChange="onModelChange"></survey-int>
        <survey-range v-if="field.type === 'RANGE'" v-bind:field="field"
                      @nodeChange="onNodeChange" @modelChange="onModelChange"></survey-range>
        <survey-slider v-if="field.type === 'VAS_SLIDER'" v-bind:field="field"
                       @nodeChange="onNodeChange" @modelChange="onModelChange"></survey-slider>
        <survey-radio-group v-if="field.type === 'GROUP_RADIO'" v-bind:field="field"
                            @nodeChange="onNodeChange"
                            @modelChange="onModelChange"></survey-radio-group>
        <survey-checkbox v-if="field.type === 'CHECKBOX'" v-bind:field="field"
                         @nodeChange="onNodeChange" @modelChange="onModelChange"></survey-checkbox>
        <survey-dropdown-group v-if="field.type === 'DROPDOWN_GROUP'" v-bind:field="field"
                               @nodeChange="onNodeChange"
                               @modelChange="onModelChange"></survey-dropdown-group>
        <survey-datepicker v-if="field.type === 'DATE'" v-bind:field="field"
                           @nodeChange="onNodeChange"
                           @modelChange="onModelChange"></survey-datepicker>
    </div>
</template>

<script>
import store from '../../store';
import SurveyService from '../../services/survey.service';
import {checkListElementCompleteness} from '../../app-func';

export default {
  name: 'SurveyField',
  props: {
    'field': null,
    'print': {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onNodeChange() {
      this.$emit('nodeChange', this.field);
    },
    onModelChange(params) {
      if(!store.state.visit.readonlyMode) {
        if (params.oldVal !== undefined) {
          SurveyService.updateSurveyFieldValue(this.$route.params.visitId,
            params.fieldId, params.newVal);
        } else if (params.newVal !== undefined) {
          SurveyService.setSurveyFieldValue(this.$route.params.visitId,
            params.fieldId, params.newVal);
        }

        if (params.newVal === undefined) {
          SurveyService.deleteSurveyFieldValue(this.$route.params.visitId,
            params.fieldId, params.index);
        }
      }
    },
    checkCompleteness (child) {
      return checkListElementCompleteness(child);
    },
  },
};
</script>

<style src="./SurveyField.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/SurveyField/SurveyField.vue